import React, { useEffect, useLayoutEffect, useState, useRef, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';


import dayjs from 'dayjs';

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    IconButton,
    Stack,
    TextField,
    InputAdornment,
    MenuItem,
    Typography,
    Autocomplete,
} from "@mui/material";

import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';


import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';
import { TimestampTZInput } from '/@/app/components/TimestampTZInput';
import { FloatingSaveControls } from '/@/app/components/FloatingSaveControls';


const STORAGE_KEY='records-input';

const formatTimestamp = (timestamp, language) =>
{
	if (timestamp == null) return '';
	return new Intl.DateTimeFormat(language, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', }).format(new Date(timestamp*1000));
};

export function recordsInputReducer(state, action)
{
let re={...state, saveState:'unsaved'};
switch (action.type)
{

case 'ASSIGN':
	re= { saveState:'saved' , ...action.value, };
	break;


case 'SET_TIMESTAMP':
	re= { ...re, timestamp: action.value.timestamp, tz: action.value.tz, timezone: action.value.timezone, };
	break;

default:
    throw new Error(`Unknown action: ${action.type}`);
}

if (re.saveState=='unsaved') localStorage.setItem(STORAGE_KEY, JSON.stringify(re));
if (re.saveState=='saved') localStorage.removeItem(STORAGE_KEY);

return re;
}

const options1 = ['Option 1', 'Option 2', 'Option 3'];
const options2 = ['Value 1', 'Value 2', 'Value 3'];

const PropTextInput = styled('input')(({ theme }) => (
{
	...theme.typography.body1,

	boxSizing: 'border-box',
	border: 0,
	outline: 0,

	background: 'transparent',
	color: theme.palette.text.primary,

	height: theme.spacing(5.5),

	'&::placeholder': { color: theme.palette.text.secondary, opacity: 1, },
}));

function PropInput({ name, value, onChange, onDelete, })
{
	const { t } = useTranslation();
	const id = React.useId();

	const inputWidth = (text) => `${text?.length ? text.length + 4 : 8}ch`;

	return (
<Box
	sx={(theme) => ({
		position: 'relative',

		display: 'inline-flex',
		alignItems: 'center',

		border: 1,
		borderColor: 'divider',
		borderRadius: `${theme.shape.borderRadius}px`,
		padding: theme.spacing(0,2),

		'&:hover': { borderColor: 'text.primary', },

		'&:focus-within': { borderColor: 'transparent', },

		'&:focus-within::after': {
			content: '""',
			position: 'absolute',
			inset: -1,
			border: 2,
			borderColor: 'primary.main',
			borderRadius: `${theme.shape.borderRadius}px`,
			pointerEvents: 'none',
		},
	})}
>
<PropTextInput list={`${id}-names`} value={name||''} onChange={(e) => onChange('name', e.target.value)} placeholder={t("Name")} style={{ width: inputWidth(name) }} />
<datalist id={`${id}-names`}> {options1.map((option) => ( <option key={option} value={option} />))} </datalist>

<Box component="span" sx={(theme)=>({ px: 0.5, color: 'text.secondary', flexShrink: 0, paddingRight:theme.spacing(2), })} > = </Box>

<PropTextInput list={`${id}-values`} value={value||''} onChange={(e) => onChange('value', e.target.value)} placeholder={t("Value")} style={{ width: inputWidth(value) }} />
<datalist id={`${id}-values`}> {options2.map((option) => ( <option key={option} value={option} />))} </datalist>

<IconButton type="button" size="small" color="secondary" onClick={onDelete} sx={{ mx: 0.5, flexShrink: 0, }} > <DeleteIcon fontSize="small" /> </IconButton>
</Box>
);
} // PropInput




export const RecordsInputView = () =>
{
const api=useApi();
const { t,i18n } = useTranslation();
const navigate = useNavigate();
const { mainViewportRef} = useContext(AppContext);

const { sessionRef } = useParams();

const [navConfirm,setNavConfirm]=useState({open:false});
const [reloadFlag,setReloadFlag]=useState(false);

const [attribs, setAttribs] = useState({});
const [props, setProps] = useState([]);
const updateProp = (row, field, value) => { setProps((current) => current.map((item, index) => index === row ? { ...item, [field]: value } : item)); };
const deleteProp = (row) => { setProps((current) => current.filter((_, index) => index !== row)); };

const { recordsInputState: state, recordsInputDispatch: dispatch, } = useContext(AppContext);

useEffect(()=>
{
	api.request(`records/input/attribs`,{},{api_url:'v2'})
	.then(re=>{ console.log('attribs',attribs); setAttribs(re); });
},[sessionRef]);

useEffect(() =>
{
	const raw = localStorage.getItem(STORAGE_KEY);
	const draft = raw ? JSON.parse(raw) : null;

	const session_ref=sessionRef || 'new';

	if (draft && draft.ref == session_ref)
	{
		dispatch({type:'ASSIGN',value:draft});
		return;
	};
	if (draft && draft.ref && !sessionRef)
	{
		navigate(`/cabinet/records/input/${draft.ref}`);
		return;
	};

	if (draft && draft.ref != session_ref)
	{
		setNavConfirm({open:true,'draft':draft});
		return;
	};
	api.request(`records/input/${session_ref}`,{},{api_url:'v2'})
	.then(re=>{ re.ref=`${re.subject},${re.version}`; dispatch({type:'ASSIGN',value:re}); });

}, [sessionRef,reloadFlag]);

useEffect(() =>
{
	if (state) setProps(Object.entries(state).map(([name, value]) => ({ name, value, })));
	console.log(state);
}, [state]);

if (!attribs) { return <></>; };

const NavConfirm=(
<Dialog open={navConfirm.open}>
<DialogTitle>{t('Подтвердите действие')}</DialogTitle>
<DialogContent>
<p>{t('Есть несохраненные изменения в сессии')}{' '}<strong>{navConfirm.draft?.ref}</strong></p>
<p>{t("Вы можете либо продолжить её редактирование, либо перейти к другой сессии, потеряв несохранённые данные")}</p>
<Box sx={{mb:2}}><Typography sx={{fontSize:'1.2rem'}}>{t('Сбросить несохранённые данные ?')}</Typography></Box>
</DialogContent>
<DialogActions>
<Button onClick={e=>{setNavConfirm({open:false});navigate(`/cabinet/records/input/${navConfirm.draft?.ref}`);}}>{t('Продолжить редактирование')}</Button>
<Button onClick={e=>{setNavConfirm({open:false});recordsInputReducer({},{type:'ASSIGN',value:{}});setReloadFlag(!reloadFlag);}} variant="contained">{t('Потерять изменения')}</Button>
</DialogActions>
</Dialog>
);

if (!state) { return NavConfirm; }

return (
<>
{NavConfirm}

<FloatingSaveControls saveState={state.saveState} onSave={()=>{}} onReset={()=>api.request(`records/input/${state.ref}`,{},{api_url:'v2'}).then(re=>{dispatch({type:'ASSIGN',value:re})})} />

<Accordion defaultExpanded>
<AccordionSummary expandIcon={<ExpandMoreIcon />}>
<Stack direction="row" alignItems="center" width="100%" spacing={0.5} >
{state.prev && <IconButton size="small" onClick={(e) => { e.stopPropagation(); navigate(`/cabinet/records/input/${state.prev_subject},${state.prev}`) }} > <ChevronLeftIcon fontSize="large"/> </IconButton> }
<Box> <Typography variant="subtitle1">{formatTimestamp(state.timestamp,i18n.language)}</Typography> <Typography variant="caption" color="text.secondary"> Measurement Session {state.ref}</Typography> </Box>
{state.next && <IconButton size="small" onClick={(e) => { e.stopPropagation(); navigate(`/cabinet/records/input/${state.next_subject},${state.next}`) }} > <ChevronRightIcon fontSize="large" /> </IconButton>}
<IconButton size="small" onClick={(e) => { e.stopPropagation(); setReloadFlag(!reloadFlag); navigate(`/cabinet/records/input/new`); }} > <AddIcon fontSize="large" /> </IconButton>
<Box sx={{ flex: 1 }} />
<IconButton size="small" onClick={(e) => { console.log(e) }} > <DeleteIcon /> </IconButton>
</Stack>
</AccordionSummary>


            <AccordionDetails>

                <Stack spacing={3}>

<TimestampTZInput value={{'timestamp':state.timestamp,'tz':state.tz,'timezone':state.timezone}} onChange={(t)=>{dispatch({type:'SET_TIMESTAMP',value:t})}} />

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        gap: 1,
      }}
    >


      {props.map((prop, row) => (
        <PropInput
          key={row}
          name={prop.name}
          value={prop.value}
          onChange={(field, value) =>
            updateProp(row, field, value)
          }
          onDelete={() => deleteProp(row)}
        />
      ))}
	</Box>



                </Stack>
<Button startIcon={<AddIcon />} variant="secondary" >{t("Добавить")}</Button>

            </AccordionDetails>

        </Accordion>
<TableContainer>
<Table>
    <TableBody>
	{state.parameters.map((row) => (
	    <TableRow key={row.id}>
		<TableCell>{row['parameter']}</TableCell>
		{row['variant'] && row['variant'].length>3?
			(<><TableCell colSpan={2} ><span>{row['variant']}</span>{row['unit-expr']}</TableCell></>)
			:(<><TableCell style={{ whiteSpace: 'nowrap' }}><span style={{fontSize:'1.5em'}}>{row['variant']||row['value']}</span> </TableCell><TableCell>{row['unit-expr']}</TableCell></>)
		}
	    </TableRow>
	))}
    </TableBody>
</Table>
</TableContainer>
<IconButton size="small" onClick={(e) => { e.stopPropagation(); }} > <AddIcon /> </IconButton>

</>
);

} // RecordsInputView
